import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { MachineListFilter } from '../../models/machines/machine-list-filter';
import { isPlatformBrowser } from '@angular/common';
import { TeamListFilter } from '../../models/teams/team-list-filter';
import { ContractorListFilter } from '../../models/contractors/contractor-list-filter';
import { ColumnGroup } from '../../models/column-group';

export const defaultMachineFilter: MachineListFilter = {
  search: [],
  machineType: [],
  productionTechnicianArea: [],
  productionLeader: [],
  ownerType: [],
  status: [],
  hasHighPrecisionCraneTipCoordinate: [],
  hasRtk: [],
  isSchoolForwarder: [],
  isGrotForwarder: [],
  isDemoMachine: []
};

export const defaultContractorFilter = {
  search: [],
  columns: [{ name: "Maskinnr", columns: "standardColumns" }],
  cities: [],
  statuses: []
};

export const defaultMachineListFilter: MachineListFilter = {
  search: [],
  machineType: [],
  productionTechnicianArea: [],
  productionLeader: [],
  ownerType: [],
  status: [],
  hasHighPrecisionCraneTipCoordinate: [],
  hasRtk: [],
  isSchoolForwarder: [],
  isGrotForwarder: [],
  isDemoMachine: []
};

export const defaultTeamListFilter: TeamListFilter = {
  search: [],
  productionTechnicianArea: [],
  productionLeader: [],
  ownerType: [],
  status: [],
};

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

  private normalizeMachineFilter(parsedData: unknown): MachineListFilter {
    const safeInput = (parsedData && typeof parsedData === 'object') ? parsedData as Partial<MachineListFilter> : {};
    const normalized: MachineListFilter = { ...defaultMachineListFilter };

    for (const key of Object.keys(defaultMachineListFilter) as (keyof MachineListFilter)[]) {
      const value = safeInput[key];
      normalized[key] = Array.isArray(value) ? value : defaultMachineListFilter[key];
    }

    return normalized;
  }

  saveMachineFilter(filters: MachineListFilter) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('machine-filter', JSON.stringify(filters));
    }
  }

  getMachineFilter(): MachineListFilter {
    if (isPlatformBrowser(this.platformId)) {
      const machineFilter = localStorage.getItem('machine-filter')
      if (machineFilter === 'undefined' || machineFilter?.length === 0 || machineFilter === null) {
        return defaultMachineListFilter;
      }

      const parsedData = JSON.parse(machineFilter);
      return this.normalizeMachineFilter(parsedData);
    }

    return defaultMachineListFilter;
  }

  getContractorFilter(): ContractorListFilter {
    if (isPlatformBrowser(this.platformId)) {
      const contractorFilter = localStorage.getItem('contractor-filter')
      if (contractorFilter === 'undefined' || contractorFilter?.length === 0 || contractorFilter === null) {
        return defaultContractorFilter;
      }

      const parsedData = JSON.parse(contractorFilter);
      const allFieldsAreLists = Object.values(parsedData).every(value => Array.isArray(value));

      if (!allFieldsAreLists) {
        return defaultContractorFilter;
      }

      return parsedData;
    }

    return defaultContractorFilter;
  }

  saveTeamFilter(filters: TeamListFilter) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('team-filter', JSON.stringify(filters));
    }
  }
  saveContractorFilter(filters: ContractorListFilter) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('contractor-filter', JSON.stringify(filters));
    }
  }


  getTeamFilter(): TeamListFilter {
    if (isPlatformBrowser(this.platformId)) {
      const teamFilter = localStorage.getItem('team-filter')
      if (teamFilter === 'undefined' || teamFilter?.length === 0 || teamFilter === null) {
        return defaultTeamListFilter;

      }

      const parsedData = JSON.parse(teamFilter);
      const allFieldsAreLists = Object.values(parsedData).every(value => Array.isArray(value));

      if (!allFieldsAreLists) {
        return defaultTeamListFilter;
      }

      return JSON.parse(teamFilter);
    }

    return defaultTeamListFilter;
  }

  fillMissingFieldsFromTemplate<T extends Record<string, any>>(input: Partial<T>, template: T, allColumnGroups: ColumnGroup[]): void {
    for (const key in template) {
      if (input[key] === undefined || input[key] === null) {
        input[key] = template[key];
      }
    }

    for (const key in input) {
      if (template[key] === undefined) {
        delete input[key];
      }
    }
  }
}
